import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import TimeAgo from 'javascript-time-ago'

import de from 'javascript-time-ago/locale/de.json'

TimeAgo.addDefaultLocale(de)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
